import { useNavigate } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import miImagen from '../assets/elsamu.jpeg'
import { useLanguage } from '../hooks/useLanguage'

export default function Creadores() {
  const { t } = useLanguage()
  const navigate = useNavigate()
  const scrollRef = useRef(null)
  const pausedRef = useRef(false)
  const rafRef = useRef(null)
  const stoppedRef = useRef(false)
  const [bankOpen, setBankOpen] = useState(false)
  const [bankClosing, setBankClosing] = useState(false)

  useEffect(() => {
    const el = scrollRef.current
    if (!el) return

    const handleManualScroll = () => {
      stoppedRef.current = true
      cancelAnimationFrame(rafRef.current)
    }
    el.addEventListener('wheel', handleManualScroll, { passive: true })
    el.addEventListener('touchmove', handleManualScroll, { passive: true })

    const tick = () => {
      if (stoppedRef.current) return
      if (!pausedRef.current) {
        el.scrollTop += 0.4
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 2) {
          stoppedRef.current = true
          return
        }
      }
      rafRef.current = requestAnimationFrame(tick)
    }

    rafRef.current = requestAnimationFrame(tick)

    return () => {
      cancelAnimationFrame(rafRef.current)
      el.removeEventListener('wheel', handleManualScroll)
      el.removeEventListener('touchmove', handleManualScroll)
    }
  }, [])

  useEffect(() => {
  if (!bankOpen) return

  const handleClickOutside = (e) => {
    // Si el click NO fue dentro del panel ni en el botón del header, cerramos
    if (!e.target.closest('[data-bank-panel]') && !e.target.closest('[data-bank-btn]')) {
      closeBank()
    }
  }

  document.addEventListener('mousedown', handleClickOutside)
  return () => document.removeEventListener('mousedown', handleClickOutside)
}, [bankOpen])

  const openBank = () => {
    setBankClosing(false)
    setBankOpen(true)
  }

  const closeBank = () => {
    setBankClosing(true)
    setTimeout(() => {
      setBankOpen(false)
      setBankClosing(false)
    }, 300)
  }

  const content = (
    <>
      <p style={{
        textAlign: 'center', fontSize: 14, letterSpacing: 3,
        textTransform: 'uppercase', color: 'var(--color-primary)',
        marginBottom: 44, fontWeight: 700
      }}>
        {t('creadores_kicker')}
      </p>

      <h1 style={{
        textAlign: 'center', fontSize: 38, fontWeight: 900,
        color: 'var(--color-text)', marginBottom: 40, lineHeight: 1.3
      }}>
        {t('creadores_titulo_principal')}
      </h1>

      <p style={{ fontSize: 20, color: 'var(--color-muted)', lineHeight: 2, marginBottom: 36, textAlign: 'justify' }}>
        {t('creadores_parrafo_1')}
      </p>

      <p style={{ fontSize: 20, color: 'var(--color-muted)', lineHeight: 2, marginBottom: 36, textAlign: 'justify' }}>
        {t('creadores_parrafo_2')}
      </p>
            <div style={{
        background: 'rgba(255,255,255,0.04)',
        border: '1px solid var(--color-border)',
        borderRadius: 20, padding: 26, marginBottom: 40
      }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--color-text)', textAlign: 'center', marginBottom: 6 }}>
          {t('creadores_fundadores_titulo')}
        </div>
        <div style={{ fontSize: 14, color: 'var(--color-primary)', textAlign: 'center', fontWeight: 600, marginBottom: 14 }}>
          Juan Felipe Villanueva Arias & Samuel Ricardo Bermudez
        </div>
      </div>

      <div style={{
        background: 'rgba(255,255,255,0.04)',
        border: '1px solid var(--color-border)',
        borderRadius: 20, padding: 26, marginBottom: 40
      }}>
        <div style={{ fontSize: 24, marginBottom: 12, textAlign: 'center' }}>🧑‍💻</div>
        <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--color-text)', textAlign: 'center', marginBottom: 6 }}>
          {t('creadores_dev_titulo')}
        </div>
        <div style={{ fontSize: 14, color: 'var(--color-primary)', textAlign: 'center', fontWeight: 600, marginBottom: 14 }}>
          Juan Felipe Villanueva Arias
        </div>
        <p style={{ fontSize: 15, color: 'var(--color-muted)', lineHeight: 1.9, textAlign: 'center' }}>
          {t('creadores_dev_desc')}
        </p>
      </div>

      <p style={{ fontSize: 20, color: 'var(--color-muted)', lineHeight: 2, marginBottom: 36, textAlign: 'justify' }}>
        {t('creadores_parrafo_3')}
      </p>

      <p style={{ fontSize: 20, color: 'var(--color-muted)', lineHeight: 2, marginBottom: 36, textAlign: 'justify' }}>
        {t('creadores_parrafo_4')}
      </p>

      <div style={{ textAlign: 'center', marginBottom: 80 }}>
        <span style={{ fontSize: 38 }}>🌟</span>
        <p style={{
          fontSize: 13, letterSpacing: 3, textTransform: 'uppercase',
          color: 'var(--color-primary)', marginTop: 12, fontWeight: 700
        }}>
          {t('creadores_footer_texto')}
        </p>
      </div>
    </>
  )

  return (
    <div style={{
      height: '100vh',
      background: 'var(--color-bg)',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      position: 'relative'
    }}>

      {/* ESTRELLAS */}
      <div style={{ position: 'fixed', inset: 0, zIndex: 0, pointerEvents: 'none', overflow: 'hidden' }}>
        {Array.from({ length: 70 }).map((_, i) => (
          <div key={i} style={{
            position: 'absolute',
            width: Math.random() * 2 + 1,
            height: Math.random() * 2 + 1,
            borderRadius: '50%',
            background: 'white',
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            opacity: Math.random() * 0.5 + 0.15,
            animation: `twinkle ${2 + Math.random() * 3}s ease-in-out infinite ${Math.random() * 3}s`
          }} />
        ))}
      </div>

      {/* HEADER */}
      <header style={{
        flexShrink: 0, zIndex: 20,
        background: 'var(--color-surface)',
        borderBottom: '1px solid var(--color-border)',
        padding: '16px 20px',
        display: 'flex', alignItems: 'center', gap: 12
      }}>
        {/* Botón volver */}
        <button
          onClick={() => navigate('/perfil')}
          style={{
            width: 36, height: 36,
            background: 'rgba(120,120,120,0.08)',
            border: '1px solid var(--color-border)',
            borderRadius: 10,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: 'pointer', fontSize: 18,
            color: 'var(--color-text)', transition: '0.2s'
          }}
          onMouseEnter={e => { e.currentTarget.style.transform = 'translateX(-2px)'; e.currentTarget.style.borderColor = 'var(--color-primary)' }}
          onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.borderColor = 'var(--color-border)' }}
        >←</button>

        {/* Título */}
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--color-text)' }}>{t('creadores_header_titulo')}</div>
          <div style={{ fontSize: 12, color: 'var(--color-muted)' }}>{t('creadores_header_subtitulo')}</div>
        </div>

        {/* Botón Apoyar — ahora en el header, a la derecha */}
        <button
          data-bank-btn
          onClick={bankOpen ? closeBank : openBank}
          style={{
            height: 36,
            paddingLeft: 14, paddingRight: 14,
            background: bankOpen
              ? 'rgba(120,120,120,0.08)'
              : 'linear-gradient(135deg, #FFCB00 0%, #E8920A 100%)',
            border: bankOpen
              ? '1px solid var(--color-border)'
              : '1px solid transparent',
            borderRadius: 10,
            display: 'flex', alignItems: 'center', gap: 6,
            cursor: 'pointer',
            fontSize: 13, fontWeight: 700,
            color: bankOpen ? 'var(--color-text)' : '#3D1F00',
            transition: '0.2s',
            boxShadow: bankOpen ? 'none' : '0 2px 12px rgba(255,180,0,0.35)',
            whiteSpace: 'nowrap',
          }}
          onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)' }}
          onMouseLeave={e => { e.currentTarget.style.transform = 'none' }}
        >
          <span style={{ fontSize: 16, animation: bankOpen ? 'none' : 'bounce 1.2s ease-in-out infinite' }}>☕</span>
          {bankOpen ? t('creadores_cerrar_btn') : t('creadores_apoyar_btn')}
        </button>
      </header>

      {/* ZONA DE SCROLL */}
      <div
        ref={scrollRef}
        style={{
          flex: 1,
          overflowY: 'scroll',
          position: 'relative',
          zIndex: 1,
        }}
        onMouseEnter={() => { pausedRef.current = true }}
        onMouseLeave={() => { pausedRef.current = false }}
        onTouchStart={() => { pausedRef.current = true }}
        onTouchEnd={() => { pausedRef.current = false }}
      >
        <div style={{
          maxWidth: 620,
          margin: '0 auto',
          padding: '80px clamp(16px, 6vw, 80px) 60px',
        }}>
          {content}
        </div>
      </div>

      {/* PANEL BANCO */}
      {bankOpen && (
        <div data-bank-panel style={{
          position: 'absolute', right: 0, top: 0, bottom: 0,
          zIndex: 50, width: 280,
          background: 'var(--color-surface)',
          borderLeft: '1px solid var(--color-border)',
          display: 'flex', flexDirection: 'column',
          justifyContent: 'center',
          padding: 16, gap: 14,
          animation: bankClosing
            ? 'slideOut 0.3s ease forwards'
            : 'slideIn 0.35s ease forwards',
        }}>
          <div style={{
            fontSize: 11, fontWeight: 700, color: 'var(--color-primary)',
            letterSpacing: 1, textTransform: 'uppercase', textAlign: 'center'
          }}>{t('creadores_panel_titulo')}</div>

          {/* Tarjeta Bancolombia */}
          <div style={{
            borderRadius: 14, padding: '14px 16px',
            background: 'linear-gradient(135deg, #FFCB00 0%, #F5A800 40%, #E8920A 100%)',
            position: 'relative', overflow: 'hidden',
            boxShadow: '0 4px 20px rgba(255,180,0,0.3)'
          }}>
            <div style={{ position: 'absolute', top: -20, right: -20, width: 90, height: 90, borderRadius: '50%', background: 'rgba(255,255,255,0.15)' }} />
            <div style={{ position: 'absolute', bottom: -30, right: 30, width: 70, height: 70, borderRadius: '50%', background: 'rgba(255,255,255,0.1)' }} />
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
              <div style={{ fontSize: 13, fontWeight: 900, color: '#5B3200', letterSpacing: 1 }}>BANCOLOMBIA</div>
              <div style={{ fontSize: 9, fontWeight: 700, color: 'rgba(91,50,0,0.7)', textTransform: 'uppercase', letterSpacing: 1 }}>{t('creadores_banco_tipo_cuenta')}</div>
            </div>
            <div style={{ fontSize: 10, color: 'rgba(91,50,0,0.6)', marginBottom: 2, letterSpacing: 1, textTransform: 'uppercase' }}>{t('creadores_banco_numero_label')}</div>
            <div style={{ fontSize: 18, fontWeight: 900, color: '#3D1F00', letterSpacing: 2, fontFamily: 'monospace', marginBottom: 10 }}>606 2468 3075</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
              <div>
                <div style={{ fontSize: 9, color: 'rgba(91,50,0,0.55)', marginBottom: 1, textTransform: 'uppercase', letterSpacing: 1 }}>{t('creadores_banco_titular_label')}</div>
                <div style={{ fontSize: 11, fontWeight: 800, color: '#3D1F00' }}>Juan Felipe Villanueva A.</div>
              </div>
              <div style={{ width: 30, height: 30, borderRadius: '50%', background: 'rgba(255,255,255,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }}>🇨🇴</div>
            </div>
          </div>
        </div>
        
      )}

      <style>{`
        @keyframes twinkle {
          0%, 100% { opacity: 0.15; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(1.5); }
        }
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-4px); }
        }
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        @keyframes slideOut {
          from { transform: translateX(0); opacity: 1; }
          to { transform: translateX(100%); opacity: 0; }
        }
      `}</style>
    </div>
  )
}